// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3o3bA","notes":"Notes_notes__2OQdh"};